import { useStore } from 'hooks/useStore';
import { observer } from 'mobx-react';
import { Dialog } from 'primereact/dialog';
import { useBulkUpdate } from './useBulkUpdate';
import ConceptListSection from './components/ConceptListSection';
import classes from './conceptList.module.scss';

const BulkUpdateModal = () => {
  const {
    MSPlanStore: { isBulkUpdateModalOpen, toggleBulkUpdateModal },
  } = useStore();
  const {
    bulkUpdateDirectTodoGFC,
    bulkUpdateDirectCompletedGFC,
    bulkUpdateIndirectTodoGFC,
    bulkUpdateIndirectCompletedGFC,
  } = useBulkUpdate();

  return (
    <Dialog
      draggable={false}
      resizable={false}
      visible={isBulkUpdateModalOpen}
      onHide={() => {
        if (!isBulkUpdateModalOpen) return;
        toggleBulkUpdateModal();
      }}
      header="Bulk Update Concepts"
      style={{
        width: '80vw',
      }}
    >
      <div className={classes.conceptListContainer}>
        <ConceptListSection
          heading="To Do"
          directData={bulkUpdateDirectTodoGFC}
          indirectData={bulkUpdateIndirectTodoGFC}
        />
        <ConceptListSection
          heading="Completed"
          directData={bulkUpdateDirectCompletedGFC}
          indirectData={bulkUpdateIndirectCompletedGFC}
        />
      </div>
    </Dialog>
  );
};

export default observer(BulkUpdateModal);
